import type { Method } from './analytics';

export type Event = [Method, ...unknown[]];

export class EventQueue {
  private queue: Event[] = [];

  enqueue(method: Method, args: unknown[]) {
    this.queue.push([method, ...args]);
  }

  dequeue() {
    return this.queue.shift();
  }

  batchDequeue(fn: (event: Event) => void) {
    while (this.length > 0) {
      const event = this.dequeue();
      if (event) {
        fn(event);
      }
    }
  }

  get length() {
    return this.queue.length;
  }
}
